// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FVNmh","left":"styles_left__uNqBR","right":"styles_right__6j0_g","count":"styles_count__CI1GX"};